module.exports = {
          srcSet: __webpack_public_path__ + "cc1913a5c0a4062587afa0ef55898627-79.png"+" 79w",
          images:[ {path: __webpack_public_path__ + "cc1913a5c0a4062587afa0ef55898627-79.png",width: 79,height: 79}],
          src: __webpack_public_path__ + "cc1913a5c0a4062587afa0ef55898627-79.png",
          toString:function(){return __webpack_public_path__ + "cc1913a5c0a4062587afa0ef55898627-79.png"},
          
          width: 79,
          height: 79
        }